export default __webpack_public_path__ + "static/media/about.c97266de.svg";